import { useState } from 'react';
import { Link } from 'react-router-dom';
import { TutorAvatar } from '@/components/tutor/TutorAvatar';
import { TutorMessage } from '@/pages/learn/study/TutorMessage';
import { demoToolPath } from './exampleData';
import { DEMO_TUTOR_NOTICE, STUDY_DEMO_TUTOR_EXAMPLES } from './demoTutorExamples';

export function StudyDemoTutorReplay({ initialKey = 'linear' }: { initialKey?: string }) {
  const [selected, setSelected] = useState(initialKey);
  const example =
    STUDY_DEMO_TUTOR_EXAMPLES.find((row) => row.item.key === selected) ??
    STUDY_DEMO_TUTOR_EXAMPLES[0];
  return (
    <section aria-label="Prepared Tutor demonstration" className="space-y-4 p-4 text-sm text-ink">
      <p className="rounded-2xl bg-wash-sunshine p-3 text-xs font-semibold">{DEMO_TUTOR_NOTICE}</p>
      <label className="block font-bold">
        View a completed tutoring example
        <select
          className="mt-2 min-h-11 w-full rounded-xl border border-hairline bg-canvas-pure p-2 text-sm"
          value={example.item.key}
          onChange={(event) => setSelected(event.target.value)}
        >
          {STUDY_DEMO_TUTOR_EXAMPLES.map((row) => (
            <option key={row.item.key} value={row.item.key}>
              {row.item.title}
            </option>
          ))}
        </select>
      </label>
      <div role="log" aria-label="Prepared Tutor conversation" className="space-y-4">
        {example.turns.map((turn) => (
          <div key={turn.turn_id} className="space-y-3">
            <div className="ml-8 rounded-2xl bg-wash-sky p-3">
              <p className="mb-1 text-xs font-bold">Alex · fictional student</p>
              <p>{turn.learner_message}</p>
            </div>
            <div className="flex gap-2">
              <TutorAvatar size="small" animated={false} expression="explaining" />
              <div className="min-w-0 flex-1 rounded-2xl bg-canvas-pure p-3">
                <p className="mb-2 text-xs font-bold text-slate2">
                  Tuan Tuan · pre-generated example
                </p>
                <TutorMessage reply={turn.reply!} />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        <Link
          className="btn-pill-secondary min-h-11 max-w-full whitespace-normal text-center"
          to={`/learn/study/working/${example.item.workingId}`}
        >
          Open the complete working
        </Link>
        <Link
          className="btn-pill-secondary min-h-11 max-w-full whitespace-normal text-center"
          to={demoToolPath(example.item)}
        >
          Explore these numbers in the tool
        </Link>
      </div>
      <p className="text-xs text-slate2">
        Read or switch the completed examples. There is no live message box in this demo.
      </p>
    </section>
  );
}
